import { z } from "zod";
import { schemas as messageSchemas } from "./message-structure-schemas";

// Re-export existing schemas for convenience
export const {
  Composition,
  ComposingEvent,
  ReasoningMetadata,
  ReferencesMetadata,
  TagReference,
  MessageMetadata,
} = messageSchemas;

// Request schemas for Composer API admin operations

export const GetCompositionRequest = z.object({
  participantId: z.string().min(1),
});

export const UpdateCompositionRequest = z.object({
  participantId: z.string().min(1),
  content: z.string(),
  threadId: z.uuid(),
  conversationId: z.uuid(),
  workspaceId: z.uuid(),
  reasoning: ReasoningMetadata.optional(),
  references: ReferencesMetadata.optional(),
  metadata: MessageMetadata.optional(),
});

export const ResetCompositionRequest = z.object({
  participantId: z.string().min(1),
});

// Response schemas
export const CompositionResponse = Composition;

export const composerSchemas = {
  GetCompositionRequest,
  UpdateCompositionRequest,
  ResetCompositionRequest,
  CompositionResponse,
  Composition,
  ComposingEvent,
  ReasoningMetadata,
  ReferencesMetadata,
  TagReference,
  MessageMetadata,
};

// // Type exports
// export type GetCompositionRequest = z.infer<typeof GetCompositionRequest>;
// export type UpdateCompositionRequest = z.infer<typeof UpdateCompositionRequest>;
// export type ResetCompositionRequest = z.infer<typeof ResetCompositionRequest>;
// export type Composition = z.infer<typeof Composition>;
// export type ComposingEvent = z.infer<typeof ComposingEvent>;
// export type ReasoningMetadata = z.infer<typeof ReasoningMetadata>;
// export type ReferencesMetadata = z.infer<typeof ReferencesMetadata>;
// export type TagReference = z.infer<typeof TagReference>;
